import axios from 'axios'
const couchDB = axios.create({
  baseURL: 'https://c4fitness.lk:4984',
  auth: {
    username: 'admin',
    password: 'c4@123',
  },
})

export const state = {
  printers: [],
}

export const getters = {
  getPrinters() {
    return state.printers
  },
}

export const mutations = {
  SET_PRINTER(state, printers) {
    state.printers = printers
  },
}

export const actions = {
  async createMembers({ commit, state }, { memberDetails }) {
    debugger
    const response = await couchDB.post('/c4_db', memberDetails)
    return response.data
  },
  async getAllMembers({ commit }, outletId) {
    const response = await couchDB.post('/c4_db/_find', {
      selector: {
        type: 'member',
      },
      limit: 10000000,
    })

    return response.data
  },
  async getMemberByBarcode({ commit }, { params }) {
    const response = await couchDB.post('/c4_db/_find', {
      selector: {
        type: 'member',
        barcode: params.barcode,
      },
      limit: 10000000,
    })

    return response.data
  },
  async getAllUnpaidMembers({ commit }, query) {
    debugger
    const response = await couchDB.post('/c4_db/_find', query)
    debugger
    return response.data
  },

  updateMembers({ commit, state }, { printerDetails }) {
    return axios.put(`v1/printer/update`, printerDetails).then(response => {
      return response
    })
  },
}
